export const parseNumber = (input) => {
	const string = input ? input.toString() : '0';
	return parseFloat(string.replace(/,/g, ''));
};

export const formatCurrency = (input, showSymbol = true, useBrackets = true, addSpace = false) => {
	/* We will tackle formatting currencies per locale/language both with front-end and
	 * back-end in FR-28188
	 */
	const originalNum = parseNumber(input);
	const num = useBrackets ? Math.abs(originalNum) : originalNum;
	const locale = window.LOCALE;
	const language = 'en'; // TODO: use locale.language (see FR-28188)
	if (num) {
		let result;
		if (showSymbol) {
			result = parseFloat(num).toLocaleString(language, {
				style: 'currency', currency: locale.currency,
			});
		} else {
			result = parseFloat(num).toLocaleString(language, {
				style: 'decimal', minimumFractionDigits: 2,
			});
		}
		if (useBrackets && originalNum < 0) {
			result = interpolate(gettext('(%(number)s)'), { number: result }, true);
		} else if (addSpace && originalNum >= 0) {
			result = `${result}&nbsp;`;
		}
		return result;
	}
	if (showSymbol && num === 0) {
		return parseFloat(0).toLocaleString(language, {
			style: 'currency',
			currency: locale.currency,
			minimumFractionDigits: 0,
		});
	}
	if (num === 0 && addSpace) {
		return '0&nbsp;';
	}
	return 0;
};

/* calls formatCurrency with some defaults */
export const formatNumber = (input) => {
	return formatCurrency(input, false, true, true);
};
